import React, { useState } from 'react'
import './Products.css'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import ProductHeader from './components/ProductHeader'
import ProductShow from './components/ProductShow'

function ProductPage() {
  const [openFilter, setOpenFiler] = useState(false)
  const setFilterOpen = React.useCallback(() => {
    setOpenFiler(!openFilter)
  }, [openFilter])
  const setFilterCLickOverlay = React.useCallback(() => {
    setOpenFiler(!openFilter)
  }, [openFilter])

  return (
    <div className="main">
      <Header />
      <ProductHeader />
      <div className="productGreeting">
        <div className="p-title"> Products </div>
        <button onClick={setFilterOpen}>Filter</button>
      </div>
      <ProductShow
        setFilterCLickOverlay={setFilterCLickOverlay}
        openFilter={openFilter}
      />
      <Footer />
    </div>
  )
}

export default React.memo(ProductPage)
